import { objectToOptionsArr, orderedOptions, reorderObjProps } from 'core/utils/utils';
import axios from 'axios';
import { ORDRE_AFFICHAGE_FAMILLE_ET_COULEURS } from 'components/Charts/Colors';

export function getPyramidAge({ colleges, souscripteurs, dateArrete }) {
    return axios.post(`/stats/pyramide_age`, { colleges, souscripteurs, dateArrete });
}

export function getEffectifsMoyens({ colleges, souscripteurs, dateArrete }) {
    return axios.post(`/stats/effectifs_moyens`, { colleges, souscripteurs, dateArrete });
}
export function getChoixAdhesion({ colleges, souscripteurs, dateArrete }) {
    return axios.post(`/stats/choix_adhesion`, { colleges, souscripteurs, dateArrete }).then((res: any) => {
        return orderedOptions(objectToOptionsArr(res));
    });
}

export function getFraisReels({ colleges, souscripteurs, dateArrete }) {
    return axios.post(`/stats/frais_reels`, { colleges, souscripteurs, dateArrete }).then((res: any) => {
        const orderedList = reorderObjProps(res, ORDRE_AFFICHAGE_FAMILLE_ET_COULEURS);
        return objectToOptionsArr(orderedList);
    });
}

export function getEffectifEnPortabilite({ colleges, souscripteurs, dateArrete }) {
    return axios.post(`/stats/effectif_en_portabilite`, { colleges, souscripteurs, dateArrete });
}
